<div class="kanban-board">
  <div class="kanban-header">
    <button class="btn btn-sm btn-primary" (click)="addColumn()">
      <i class="bi bi-plus"></i> Add column
    </button>
    <div class="kanban-header-actions">
      <ng-content select="[kanban-header-actions]"></ng-content>
    </div>
  </div>

  <div class="kanban-columns" (dragover)="onColumnDragOver($event)">
    @for (col of columns; track col.id; let colIndex = $index) {
      <div
        class="kanban-column"
        [style.width.px]="getColumnWidthPx(col)"
        (drop)="onColumnDrop($event, colIndex)"
        >
        <div class="column-header">
          @if (editingColumnId !== col.id) {
            <h6 class="title" (dblclick)="editingColumnId = col.id">{{ col.title }}</h6>
            <div class="actions">
              <button
                class="btn btn-sm btn-light drag-handle"
                type="button"
                [ngbTooltip]="'Reorder column'"
                placement="top"
                container="body"
                draggable="true"
                (dragstart)="onColumnDragStart($event, colIndex)"
              >
                <i class="bi bi-grip-vertical"></i>
              </button>
              <button
                class="btn btn-sm btn-light resize-handle"
                type="button"
                [ngbTooltip]="'Adjust column width'"
                placement="top"
                container="body"
                (pointerdown)="onResizeHandlePointerDown($event, col)"
              >
                <i class="bi bi-arrow-left-right"></i>
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="editingColumnId = col.id"
                [ngbTooltip]="'Edit column'"
                placement="top"
                container="body"
              >
                <i class="bi bi-pencil"></i>
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="deleteColumn(col)"
                [ngbTooltip]="'Delete column'"
                placement="top"
                container="body"
              >
                <i class="bi bi-trash"></i>
              </button>
              <button
                class="btn btn-sm btn-primary"
                (click)="addCard(col)"
                [ngbTooltip]="'Add ticket'"
                placement="top"
                container="body"
              >
                <i class="bi bi-plus"></i>
              </button>
            </div>
          } @else {
            <form (submit)="$event.preventDefault(); renameColumn(col, titleInput.value)" class="edit-form">
              <input #titleInput class="form-control form-control-sm" [value]="col.title" />
            </form>
          }
        </div>
        <div class="cards" (dragover)="onCardDragOver($event)" (drop)="onCardDrop($event, col.id)">
          @for (card of col.cards; track card.id; let cardIndex = $index) {
            <div
              class="card-item"
              [class.selected]="selectedCardId === card.id"
              draggable="true"
              (dragstart)="onCardDragStart($event, col.id, card.id)"
              (dragover)="onCardDragOver($event)"
              (drop)="onCardDrop($event, col.id, cardIndex)"
              (click)="onCardClick(col.id, card)"
              >
              @if (editingCardId !== card.id) {
                <div class="card-title" (dblclick)="editingCardId = card.id">
                  @if (card.ticketNumber) {
                    <span class="badge text-bg-light border me-1">#{{ card.ticketNumber }}</span>
                  }
                  {{ card.title }}
                </div>
                @if (prStatusLabel(card)) {
                  <div class="mb-1 d-flex align-items-center gap-1">
                    <span class="badge" [class]="prStatusBadgeClass(card)">{{ prStatusLabel(card) }}</span>
                    @if (card.pr?.url) {
                      <a [href]="card.pr?.url" target="_blank" rel="noopener noreferrer" class="small">PR</a>
                    }
                  </div>
                }
                @if (card.description) {
                  <div class="card-description">{{ card.description }}</div>
                }
                @if (latestFeedback(card)) {
                  <div class="card-feedback">{{ latestFeedback(card) }}</div>
                }
                @if (agentifyStatusLabel(card)) {
                  <div class="card-agentify-status">{{ agentifyStatusLabel(card) }}</div>
                }
                <div class="card-actions">
                  <button
                    class="btn btn-sm btn-light"
                    (click)="$event.stopPropagation(); editingCardId = card.id"
                    [ngbTooltip]="'Edit ticket'"
                    placement="top"
                    container="body"
                  >
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-light"
                    (click)="$event.stopPropagation(); deleteCard(col, card.id)"
                    [ngbTooltip]="'Delete ticket'"
                    placement="top"
                    container="body"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                  @if (canAgentifyCard(col, card)) {
                    <button
                      class="btn btn-sm btn-primary card-agentify-btn"
                      (click)="onAgentifyClick(col, card, $event)"
                      [disabled]="isAgentifyingCard(card)"
                      [ngbTooltip]="agentifyTooltip(card)"
                      placement="top"
                      container="body"
                    >
                      @if (isAgentifyingCard(card)) {
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      } @else {
                        Agentify
                      }
                    </button>
                  }
                  @if (canResumeCard(col, card)) {
                    <button
                      class="btn btn-sm btn-outline-primary"
                      (click)="onResumeClick(col, card, $event)"
                      [ngbTooltip]="'Resume failed run from saved draft'"
                      placement="top"
                      container="body"
                    >
                      Retry
                    </button>
                  }
                </div>
              } @else {
                <form (submit)="$event.preventDefault(); editCard(card, title.value, desc.value)" class="edit-form">
                  <input #title class="form-control form-control-sm" [value]="card.title" placeholder="Title" />
                  <textarea #desc class="form-control form-control-sm" [value]="card.description" placeholder="Description"></textarea>
                  <div class="mt-1 d-flex gap-1">
                    <button type="submit" class="btn btn-sm btn-primary">Save</button>
                    <button type="button" class="btn btn-sm btn-light" (click)="cancelCardEdit(col, card)">Cancel</button>
                  </div>
                </form>
              }
            </div>
          }
        </div>
      </div>
    }

    <div class="kanban-column column-dropzone" (dragover)="onColumnDragOver($event)" (drop)="onColumnDrop($event, columns.length)">
      <div class="column-dropzone-inner">Drop column here</div>
    </div>
  </div>
</div>


